<template>
  <div class="container">
    <!-- <div v-title data-title={{pageTitle}}></div> -->
    <h3 v-if="showTitle">{{title}}</h3>
    <div v-html="richHtml" class="rich-box"></div>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        menuList: [],
        imgList: [],
        richHtml: '',
        id: '',
        postfix:"",//来源
        title: '',
        showTitle: false,
        pageTitle: ''
      }
    },
    created() {
      if (this.$route.query.id) {
        this.id = this.$route.query.id;
      }
      if (this.$route.query.utm_source) {
        this.postfix = this.$route.query.utm_source;
      }
      this.getInfo();
    },
    mounted() {
      //给所有的a标签添加点击事件


    },
    methods: {
      getInfo() {
        let that = this;
        this.http({
          url: this.getdetail + '?id=' + this.id + "&postfix=" + this.postfix,
          method: 'get',
        }).then(res => {
          if (res.data.code == 2000) {
            let data = res.data.data;
            this.title = data.title;
            this.richHtml = data.detail;
            this.pageTitle = data.pageTitle;
            document.title = this.pageTitle;
            console.log("data.pageTitle-------", data.pageTitle)
            let title = data.title.replace(/\s+/g, ""); //去空格后检测是否存在title
            console.log("title--------", title.length)
            if (title.length > 0) {
              this.showTitle = true;
            }
            this.$nextTick(() => {
              let aTags = document.getElementsByTagName('a')
              console.log(aTags)
              for (let i = 0; i < aTags.length; i++) {

                let item = aTags[i]
                let href = item.href;
                //如果是有赞店铺，不做处理
                if(href.indexOf("youzan.com") < 0){
                  if (href.indexOf("?gid=") > -1) {
                    //新版本
                    let url = href + "&utm_source=" + data.postfix
                    item.removeAttribute("href");
                    item.setAttribute('href', url)
                  } else {
                    //老版本兼容
                    let hrefArr = href.split("?");
                    if (hrefArr.length > 0) {
                      console.log(hrefArr[0], 'hrefArr[0]')
                      let url = hrefArr[0] + "?utm_source=" + data.postfix
                      item.removeAttribute("href");
                      item.setAttribute('href', url)
                    }
                  }
                }




              }

              var ua = navigator.userAgent.toLowerCase();
              if (ua.match(/MicroMessenger/i) == "micromessenger") {
                //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
                wx.miniProgram.getEnv((res) => {
                  if (res.miniprogram) {
                    // alert("在小程序里");
                    var alist = document.getElementsByTagName("a");
                    for (var i = 0; i < alist.length; i++) {

                      let href = alist[i].getAttribute("href");
                      // https://item.reflower.com.cn/detail/0J_Qn9Cc0JzQl9Cb?utm_source=ts3
                      //领取优惠券
                      if (href.indexOf("/newactivity/") > -1) {
                        let title = alist[i].getAttribute("title");
                        alist[i].setAttribute("newactivity_url", title);

                        alist[i].setAttribute("href", "javascript:void(0);");
                        //设置自定义h5_projectid
                        alist[i].onclick = function(ebent) {

                          var newactivity_url = $(this).attr("newactivity_url");
                          that.gotoNewactivity(newactivity_url);
                        }
                      } else if(href.indexOf("/ShoppingGold") > -1){
                        //跳转购物金
                        alist[i].setAttribute("href", "javascript:void(0);");
                        //设置自定义h5_projectid
                        alist[i].onclick = function(ebent) {
                          that.gotoShoppingGold(data.postfix);
                        }

                      } else if(href.indexOf("pages/activity11/index") > -1){
                        //跳转铃兰灯活动
                        alist[i].setAttribute("href", "javascript:void(0);");
                        //设置自定义h5_projectid
                        alist[i].onclick = function(ebent) {
                          that.gotoActivity11(data.postfix);
                        }

                      }else if(href.indexOf("pages/activityCloud/index") > -1){
                        //跳转铃兰灯活动
                        alist[i].setAttribute("href", "javascript:void(0);");
                        //设置自定义h5_projectid
                        alist[i].onclick = function(ebent) {
                          that.gotoActivityCloud(data.postfix);
                        }

                      }else if (href.indexOf("?gid=") > -1) {
                        let firstHref = "";
                        if (href.indexOf("?gid=") >= 0 && href.indexOf("utm_source") < 0) {
                          firstHref = href;
                        } else {
                          let hrefArr = href.split("&");
                          firstHref = hrefArr[0];
                        }
                        let list = firstHref.split("?gid=");
                        alist[i].setAttribute("h5_projectid", list[1]);

                        alist[i].setAttribute("href", "javascript:void(0);");
                        //设置自定义h5_projectid
                        alist[i].onclick = function(ebent) {
                          var h5_projectid = $(this).attr("h5_projectid");
                          that.goWxMin(h5_projectid, data.postfix);
                        }
                      } else if (href.indexOf("detail/") > -1) {
                        //老版本
                        let firstHref = "";
                        if (href.indexOf("?") >= 0) {
                          let hrefArr = href.split("?");
                          firstHref = hrefArr[0];
                        } else {
                          firstHref = href;
                        }
                        let list = firstHref.split("detail/");
                        alist[i].setAttribute("h5_projectid", list[1]);

                        alist[i].setAttribute("href", "javascript:void(0);");
                        //设置自定义h5_projectid
                        alist[i].onclick = function(ebent) {
                          var h5_projectid = $(this).attr("h5_projectid");
                          that.goWxMin(h5_projectid, data.postfix);
                        }
                      }

                    }
                  } else {
                    // alert("不在小程序里");
                  }
                })
              } else {
                // alert('不在微信里');
              }
            })


          } else {
            this.popUp(res.data.msg)
          }
        })
      },
      popUp: function(content) {
        layer.open({
          content: content,
          skin: 'msg',
          time: 2 //2秒后自动关闭
        });
      },
      goWxMin: function(h5_projectid, postfix) {
        // https://item.reflower.com.cn/detail/0J_Qn9Cc0JzQl9Cb?utm_source=ts3
        wx.miniProgram.navigateTo({
          url: '/pages/shareProduct/index?h5_projectid=' + h5_projectid + "&utm_source=" + postfix
        });
      },
      gotoNewactivity: function(url) {
        wx.miniProgram.navigateTo({
          url: '/pages/newactivityUrl/index?url=' + encodeURIComponent(url)
        });
      },
      gotoShoppingGold: function(postfix) {
        wx.miniProgram.navigateTo({
          url: '/pages/shoppingGold/index?utm_source=' + postfix
        });
      },
      gotoActivity11: function(postfix) {
        wx.miniProgram.navigateTo({
          url: '/pages/activity11/index?utm_source=' + postfix
        });
      },
      gotoActivityCloud: function(postfix) {
        wx.miniProgram.navigateTo({
          url: '/pages/activityCloud/index?utm_source=' + postfix
        });
      }
    }
  }
</script>

<style scoped="scoped">
  .container {
    height: 100vh;
    background-color: #FFFFFF;
    padding-bottom: 0.533333rem;
    /* padding-top: 0.4rem; */
  }

  .container h3 {
    font-size: 0.426666rem;
    font-weight: normal;
    height: 0.8rem;
    text-align: left;
    margin: 0 0.4rem;
    border-bottom: 1px solid #DDDDDD;
  }

  .rich-box {
    padding: 0.266666rem 0.4rem;
  }

  .rich-box>>>p {
    font-size: 0.266666rem;
    text-align: left;
    line-height: 0.533333rem;
  }

  .rich-box>>>img {
    max-width: 9.2rem;
    margin-top: -1px;
  }

  .rich-box>>>h4 {
    font-size: 0.4rem;
    text-align: left;
  }

  .rich-box>>>h3 {
    font-size: 0.426666rem;
  }

  .rich-box>>>h2 {
    font-size: 0.453333rem;
  }

  .rich-box>>>h1 {
    font-size: 0.48rem;
  }
</style>



// WEBPACK FOOTER //
// src/path/servicePage/richPage.vue